import { render, staticRenderFns } from "./IndexSale.vue?vue&type=template&id=1a1a9e34&scoped=true&"
import script from "./IndexSale.vue?vue&type=script&lang=js&"
export * from "./IndexSale.vue?vue&type=script&lang=js&"
import style0 from "./IndexSale.vue?vue&type=style&index=0&id=1a1a9e34&scoped=true&lang=css&"
import style1 from "./IndexSale.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a9e34",
  null
  
)

export default component.exports
import {QBtn,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QTable})
